export function claimArtworkGenerationRequest(claimedSignals, signal) {
  if (!signal || claimedSignals.has(signal)) return false;
  claimedSignals.add(signal);
  return true;
}
